export default "__VITE_ASSET__ClQxDwmK__"